/**
 * Challenge Definitions
 * Default challenges for the system
 */

export const CHALLENGE_TYPES = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY'
};

export const DEFAULT_DAILY_CHALLENGES = [
  {
    challengeId: 'DAILY_SHIFT_1',
    challengeType: CHALLENGE_TYPES.DAILY,
    name: 'Complete 1 Shift',
    nameThai: 'ทำเวร 1 เวร',
    description: 'ทำเวรให้เสร็จสิ้นอย่างน้อย 1 เวรวันนี้',
    requirement: {
      type: 'shifts_completed',
      value: 1,
      period: 'day'
    },
    reward: {
      points: 50,
      xp: 100,
      coins: 10
    }
  },
  {
    challengeId: 'DAILY_INSPECT_3',
    challengeType: CHALLENGE_TYPES.DAILY,
    name: 'Inspect 3 Equipment',
    nameThai: 'ตรวจสอบอุปกรณ์ 3 ชิ้น',
    description: 'ตรวจสอบอุปกรณ์อย่างน้อย 3 ชิ้นวันนี้',
    requirement: {
      type: 'inspections_completed',
      value: 3,
      period: 'day'
    },
    reward: {
      points: 45,
      xp: 75,
      coins: 9
    }
  },
  {
    challengeId: 'DAILY_CLOCK_ON_TIME',
    challengeType: CHALLENGE_TYPES.DAILY,
    name: 'Clock In On Time',
    nameThai: 'เข้าเวรตรงเวลา',
    description: 'เข้าเวรภายใน 15 นาทีหลังจากเริ่มเวร',
    requirement: {
      type: 'clock_in_on_time',
      value: 1,
      period: 'day'
    },
    reward: {
      points: 20,
      xp: 40,
      coins: 4
    }
  },
  {
    challengeId: 'DAILY_GIVE_GIFT',
    challengeType: CHALLENGE_TYPES.DAILY,
    name: 'Give 1 Gift',
    nameThai: 'ให้ของขวัญ 1 ชิ้น',
    description: 'ให้ของขวัญแก่สมาชิกทีม 1 ชิ้นวันนี้',
    requirement: {
      type: 'gifts_given',
      value: 1,
      period: 'day'
    },
    reward: {
      points: 30,
      xp: 50,
      coins: 5
    }
  }
];

export const DEFAULT_WEEKLY_CHALLENGES = [
  {
    challengeId: 'WEEKLY_SHIFTS_5',
    challengeType: CHALLENGE_TYPES.WEEKLY,
    name: 'Complete 5 Shifts',
    nameThai: 'ทำเวร 5 เวร',
    description: 'ทำเวรให้เสร็จสิ้นอย่างน้อย 5 เวรในสัปดาห์นี้',
    requirement: {
      type: 'shifts_completed',
      value: 5,
      period: 'week'
    },
    reward: {
      points: 250,
      xp: 500,
      coins: 50
    }
  },
  {
    challengeId: 'WEEKLY_PERFECT_ATTENDANCE',
    challengeType: CHALLENGE_TYPES.WEEKLY,
    name: 'Perfect Attendance',
    nameThai: 'มาเวรครบถ้วน',
    description: 'ทำเวรที่ได้รับมอบหมายทั้งหมดในสัปดาห์นี้',
    requirement: {
      type: 'perfect_attendance',
      value: 1,
      period: 'week'
    },
    reward: {
      points: 300,
      xp: 600,
      coins: 60
    }
  },
  {
    challengeId: 'WEEKLY_INSPECT_20',
    challengeType: CHALLENGE_TYPES.WEEKLY,
    name: 'Inspect 20 Equipment',
    nameThai: 'ตรวจสอบอุปกรณ์ 20 ชิ้น',
    description: 'ตรวจสอบอุปกรณ์อย่างน้อย 20 ชิ้นในสัปดาห์นี้',
    requirement: {
      type: 'inspections_completed',
      value: 20,
      period: 'week'
    },
    reward: {
      points: 300,
      xp: 500,
      coins: 50
    }
  },
  {
    challengeId: 'WEEKLY_TEAM_COLLABORATION',
    challengeType: CHALLENGE_TYPES.WEEKLY,
    name: 'Team Collaboration',
    nameThai: 'ทำงานร่วมกัน',
    description: 'เข้าร่วมกิจกรรมทีม 5 ครั้งในสัปดาห์นี้',
    requirement: {
      type: 'team_activities',
      value: 5,
      period: 'week'
    },
    reward: {
      points: 250,
      xp: 400,
      coins: 40
    }
  }
];

export const DEFAULT_MONTHLY_CHALLENGES = [
  {
    challengeId: 'MONTHLY_SHIFTS_20',
    challengeType: CHALLENGE_TYPES.MONTHLY,
    name: 'Complete 20 Shifts',
    nameThai: 'ทำเวร 20 เวร',
    description: 'ทำเวรให้เสร็จสิ้นอย่างน้อย 20 เวรในเดือนนี้',
    requirement: {
      type: 'shifts_completed',
      value: 20,
      period: 'month'
    },
    reward: {
      points: 1000,
      xp: 2000,
      coins: 200
    }
  },
  {
    challengeId: 'MONTHLY_EQUIPMENT_MASTER',
    challengeType: CHALLENGE_TYPES.MONTHLY,
    name: 'Equipment Master',
    nameThai: 'ผู้เชี่ยวชาญอุปกรณ์',
    description: 'ตรวจสอบอุปกรณ์ 100 ชิ้นในเดือนนี้',
    requirement: {
      type: 'inspections_completed',
      value: 100,
      period: 'month'
    },
    reward: {
      points: 1500,
      xp: 2500,
      coins: 250
    }
  },
  {
    challengeId: 'MONTHLY_TEAM_LEADER',
    challengeType: CHALLENGE_TYPES.MONTHLY,
    name: 'Team Leader',
    nameThai: 'ผู้นำทีม',
    description: 'นำกิจกรรมทีม 10 ครั้งในเดือนนี้',
    requirement: {
      type: 'team_activities_led',
      value: 10,
      period: 'month'
    },
    reward: {
      points: 1200,
      xp: 2000,
      coins: 200
    }
  },
  {
    challengeId: 'MONTHLY_GIFT_AMBASSADOR',
    challengeType: CHALLENGE_TYPES.MONTHLY,
    name: 'Gift Ambassador',
    nameThai: 'ทูตของขวัญ',
    description: 'ให้ของขวัญ 20 ชิ้นในเดือนนี้',
    requirement: {
      type: 'gifts_given',
      value: 20,
      period: 'month'
    },
    reward: {
      points: 800,
      xp: 1500,
      coins: 150
    }
  }
];

